import { createBrowserHistory } from 'history';
export const history = createBrowserHistory();
export const events = { edit: false };